import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["value", "disabled"]
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:modelValue', (e.target as HTMLInputElement).value)),
      type: "url",
      placeholder: "URL",
      class: "form-input",
      disabled: _ctx.disabled,
      required: ""
    }, null, 40, _hoisted_2),
    _createElementVNode("button", {
      type: "submit",
      disabled: _ctx.disabled,
      class: "text-white bg-matte-blue h-full px-4 rounded-2xl absolute right-0 disabled:bg-matte-dark-blue disabled:text-zinc-400 hover:bg-white hover:text-matte-light-blue"
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "fa-solid fa-paper-plane" }, null, -1)
    ]), 8, _hoisted_3)
  ]))
}